import { useSelector } from 'react-redux'
import { selectEnvironment } from '@/store/hederaSettingsSlice'

export const useEnvironment = (): 'evm' | 'hedera' => {
  return useSelector(selectEnvironment)
}

export const useRoutePrefix = (): string => {
  const environment = useEnvironment()
  return environment === 'hedera' ? '/hedera' : '/evm'
}
